export default __webpack_public_path__ + "assets/pdf/TermosCondicoes.b1fdd2fd.pdf";